import { Model } from "./model";

import { Rank } from "./rank.model";

export class User extends Model {
    id: number;
    brand_id: number;
    country_id: number;
    language_id: number;
    retailer_id?: null;
    role_id: number;
    shop_id?: number;
    activated: number;
    avatar: string;
    avatar_url: string;
    brand_logo: string;
    brand_white_logo: string;
    brand_logo_url: string;
    brand_white_logo_url: string;
    brand_name: string;
    country_flag: string;
    country_name: string;
    country_challenges_enabled: number;
    tos_and_privacy?: string;
    created: string;
    delivery_address?: string;
    modified?: string;
    email: string;
    firstname: string;
    language_code: string;
    language_flag: string;
    language_locale: string;
    language_name: string;
    lastname: string;
    points: number;
    retailer_logo: string;
    retailer_logo_url: string;
    retailer_name?: string;
    role_name: string;
    role_title: string;
    shop_name?: string;
    username: string;

    password?: string;
    password_conf?: string;

    rank: Rank;
    rank_name: string;
    rank_progress: number;
}



// WEBPACK FOOTER //
// ./src/models/user.model.ts